import React, { useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { notify } from '../../../utils/notification';

/** This creature's effect that it can spend its action to shake off, while it's still its choice this turn. */
export const pendingActionSave = (combatState, combatantId) => {
  const id = String(combatantId || '');
  const active = combatState?.participants?.[combatState?.activeTurn];
  if (!id || String(active?.characterId || active?.enemyId || '') !== id) return null;
  const ledger = combatState.turnActionLedger?.combatantId === id && combatState.turnActionLedger.turnSequence === combatState.turnSequence ? combatState.turnActionLedger : null;
  if (ledger?.actionSpent || ledger?.danceDeclinedFor === combatState.turnSequence) return null;
  return (combatState.activeEffects || []).find(effect => effect?.actionSave && String(effect.targetCombatantId) === id) || null;
};

// Irresistible Dance: comes up on the dancer's turn, for its player or, for a monster, the DM.
export default function ActionSavePrompt({ campaignId, combatantId, name, combatState, onCombatStateReconciled }) {
  const [busy, setBusy] = useState(false);
  const lock = useRef(false);
  const effect = pendingActionSave(combatState, combatantId);
  if (!effect) return null;
  const decide = async decision => {
    if (lock.current) return;
    lock.current = true; setBusy(true);
    try {
      const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/buffs/action-save`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: `action-save:${effect.id}:${combatState.turnSequence}`, effectId: effect.id, combatantId: String(combatantId), decision }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'The save could not be made.');
      onCombatStateReconciled?.(result.combat);
      if (decision === 'use') notify(`${effect.name}: ${result.total} against DC ${result.dc}. ${result.success ? 'It ends.' : effect.actionSave.skill ? 'Still held.' : 'Still dancing.'}`, result.success ? 'success' : 'warning');
    } catch (failure) { notify(failure.message, 'danger'); }
    finally { lock.current = false; setBusy(false); }
  };
  const ability = effect.actionSave.ability.charAt(0).toUpperCase() + effect.actionSave.ability.slice(1);
  const escape = effect.actionSave.skill === 'athletics';
  return <Modal show centered backdrop="static" keyboard={false} className="dnd-modal modern-modal" aria-label="Collect yourself">
    <Modal.Header><Modal.Title>{escape ? 'Break free?' : 'Collect yourself?'}</Modal.Title></Modal.Header>
    <Modal.Body><p>{name ? `${name} can` : 'You can'} spend an Action on a {escape ? 'Strength (Athletics) check' : `${ability} save`} (DC {effect.actionSave.dc}) to end {effect.name.split(' \u00b7 ')[1] || effect.name}.</p></Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" disabled={busy} onClick={() => decide('skip')}>{escape ? 'Stay put' : 'Keep dancing'}</Button>
      <Button disabled={busy} onClick={() => decide('use')}>Use the Action</Button>
    </Modal.Footer>
  </Modal>;
}
